module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/05-85010002c9f2829c15093bb3b9331cf3.jpg";